import { useEffect } from 'react';
import './App.scss';
import AppRoutes from './routes/AppRoutes';
import { AVR_ENABLE_GTM, AVR_GTM_ID } from './config/env';
import { loadGTM } from './utils/gtm';

function App() {
  useEffect(() => {
    const isEnabled =
      AVR_ENABLE_GTM === "true" || AVR_ENABLE_GTM === true;

    if (isEnabled) {
      loadGTM(AVR_GTM_ID);
    }
  }, []);

  return <AppRoutes />;
}

export default App;
